module.exports = __webpack_public_path__ + "static/media/default.88af50db.svg";